import React, { useState, useEffect } from 'react'
import DashboardLayout from '../../components/layouts/DashboardLayout'
import AccountHeader from '../../components/Account/AccountHeader'
import Item from '../../components/Dashboard/Store/Item'
import TabButton from '../../components/Dashboard/Store/TabButton'
import RewardPoints from '../../components/Dashboard/Store/RewardPoints'
import SpinnerComp from '../../components/SpinnerComp'
import InputComp from '../../components/InputComp'
import SelectComp from '../../components/SelectComp'
import ConfirmationModal from '../../components/ConfirmationModalComp'
import RewardHistory from '../../components/Dashboard/Store/RewardHistory';
import useStore from '../../hooks/useStore';
import { useModalStore } from '../../store/useModalStore'
import HomeModals from './Modals/HomeModals'
import EmptyScreenComp from '../../components/EmptyScreenComp';
import states from '../../consts/states';
import CommunityChallenge from '../../components/Dashboard/CommunityChallenge';
import PlacesSearchComp from '../../components/Google/PlacesSearchComp';




const Store: React.FC = () => {
  const {
    rewards,
    rewardHistory,
    loading,
    lessPoints,
    currentPage,
    totalPages,
    showModal,
    selectedRewardId,
    tab,
    handleRedeemReward,
    showModalPopup,
    handlePageChange,
    setTab,
    setShowModal,
    setLessPoints,
    user,
    rewardHistoryLoading,
    street,
    addedAddresses,
    showInputAddress,
    setStreet,
    setAddedAddresses,
    setShowInputAddress,
    addressId,
    setAddressId,
    addressRelatedError,
    setAddressRelatedError,
    selected,
    setSelected,
    setCity,
    setCountry,
    setState,
    setZip,
    city,
    country,
    state,
    zip,
    communityChallenges,
    communityProgress,
    selectedPlace,
    handlePlaceSelect
  } = useStore();

  const { modalStates, updateModalState } = useModalStore();

  const renderTabContent = () => {
    if (tab === 'available') {
      return rewards.map((reward: any, index) => (
        <Item
          key={reward.id}
          {...reward}
          index={index}
          length={rewards.length}
          onRedeem={() => showModalPopup(reward.id)}
          selected={selected}
          onSelect={setSelected}
        />
      ));
    } else {
      return <RewardHistory
        rewardHistory={rewardHistory}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        loading={loading}
      />
    }
  };
  const getOptions = (): { value: string; label: string; }[] => {
    const options = addedAddresses.map((address: { id: number, address: string }) => ({
      value: address.id.toString(), 
      label: address.address,
    }));

    options.push({
      value: 'showInput',
      label: 'Add new address',
    });

    return options;
  };
  return (

    <DashboardLayout title='Store' description=''>
      <div className='mb-48 md:mb-12'>
        {/* Account header */}
        <AccountHeader
          title='Rewards'
          showNavigation={false}
          onAddPress={() => updateModalState('isModalOpen', true)}
        />
        {/* Add Cigar */}
        <HomeModals
          {...modalStates}
          setIsModalOpen={(value) => updateModalState('isModalOpen', value)}
          setIsCigarModalOpen={(value) => updateModalState('isCigarModalOpen', value)}
        />
        {loading && (
          <SpinnerComp />
        )}


        {/* Confirm model for reward redmptions. */}
        {showModal && !lessPoints && (
          <ConfirmationModal
            title='Redeem Reward'
            message='Enter your shipping address or choose existing address and Redeem your Reward.'
            onConfirm={() => handleRedeemReward(selectedRewardId)}
            onClose={() => setShowModal(false)}
            isOpen={showModal}
            confirmButtonText='Redeem'
            cancelButtonText='Cancel'
          >
            {/* ask for address */}
            <div className='mb-4'>
              {showInputAddress && (
                <>
                  <div className="mt-2">
                    <label className='block text-left text-sm font-medium text-white opacity-70 mb-1'>
                      Search for your address
                    </label>
                    <PlacesSearchComp onPlaceSelect={handlePlaceSelect} />
                  </div>
                  {selectedPlace && (
                    <div className="mt-2 p-3 bg-primary-blue-80 rounded-xl">
                      <p className="text-white text-sm">
                        <strong>Selected Address:</strong><br />
                        {selectedPlace.address}
                      </p>
                    </div>
                  )}
                </>
              )}
              <div className='mt-4'>
                <SelectComp
                  label='Existing Addresses'
                  options={getOptions()}
                  value={!showInputAddress ? (getOptions()[0]?.label || 'Add new address') : 'Add new address'}
                  onChange={(value: string) => {
                    setAddressRelatedError("");
                    if (value === 'showInput') {
                      setShowInputAddress(true);
                      setAddressId(-1);
                    } else {
                      setAddressId(parseInt(value));
                      setShowInputAddress(false);
                    }
                  }
                  }
                />
              </div>
            </div>
          </ConfirmationModal>
        )}

        {/* User Reward points for mobile */}
        <div className='md:hidden mb-2'>
          <RewardPoints current={user.balance} total={user.total_points} />
        </div>

        {/* Tab's in mpbile */}
        <div className='flex flex-row ml-1 mt-4 md:hidden'>
          <TabButton label="Available" isActive={tab === 'available'} onClick={() => setTab('available')} />
          <TabButton label="Redeemed" isActive={tab === 'history'} onClick={() => setTab('history')} />
        </div>

        {!loading && rewards.length === 0 &&
          <div className='col-span-9'>
            <EmptyScreenComp
              title='No rewards available'
              description='Check back later for more rewards'
            />
          </div>}

        {/* Rewards and Challenges */}
        {rewards.length > 0 &&
        <div className='grid grid-cols-1 md:grid-cols-12 lg:grid-cols-12 gap-4 mt-4 md:mt-0'>
            {!loading && rewards.length > 0 &&
              <div className='col-span-9 rounded-2xl p-4 mb-4'>
                {/* Add Community Challenges inside rewards section */}
                {communityChallenges.length > 0 && (
                  <div className="mb-6">
                    <h2 className="text-white text-xl font-semibold mb-4">
                      Community Challenges
                    </h2>
                    {communityChallenges.map((challenge) => (
                      <CommunityChallenge
                        key={challenge.id}
                        challenge={challenge}
                      />
                    ))}
                  </div>
                )}

                {renderTabContent()}
              </div>}

            {/* Reward points and history (existing code) */}
            {!loading && <div className='hidden md:block col-span-3 border border-primary-blue-90 rounded-2xl mb-4'>
              <RewardPoints current={user.balance} total={user.total_points} />
              <RewardHistory
                rewardHistory={rewardHistory}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                loading={loading}
              />
            </div>}
          </div>}
      </div>
    </DashboardLayout>
  )
}

export default Store
